import { useEffect } from 'react';
import { User } from '@auth0/auth0-react';
import { GVSnackbar } from 'components/common';
import { useDispatch } from 'react-redux';
import { getOrganizationId, isAdmin, isCustomProfiler, isSuperAdmin, isTenantAdmin, isTenantManager } from 'utils/auth';
import { fetchActiveUserOrganization, fetchOrganizations } from 'store/myAccount/requests';
import { getRoles } from 'store/myAccount/requests';
import DropdownMenu from './DropdownMenu';
import Layout from './Layout';
import { useUserStateStore } from 'zstore/userStateStore';
import styles from './index.module.css';

const MyAccountPage = () => {
  const dispatch = useDispatch();
  const { user } = useUserStateStore();

  const hasAdminRights =
    user?.sub && (isAdmin(user as User) || isTenantAdmin(user as User) || isSuperAdmin(user as User));
  const hasManagerRights =
    user?.sub && (isTenantManager(user as User) || isSuperAdmin(user as User) || isCustomProfiler(user as User));

  // for Admin, tenantAdmin, and superAdmin
  useEffect(() => {
    if (hasAdminRights) {
      dispatch(fetchActiveUserOrganization(getOrganizationId(user as User), true, true));
      dispatch(getRoles());
    } else {
      dispatch(fetchActiveUserOrganization(getOrganizationId(user as User)));
    }
  }, [hasAdminRights]);

  // for tenantManagers and superAdmin
  useEffect(() => {
    if (hasManagerRights) {
      dispatch(fetchOrganizations());
    }
  }, [hasManagerRights]);

  return (
    <div className={styles.page}>
      <div className={styles.menu}>
        <DropdownMenu />
      </div>
      <div className={styles.content}>
        <Layout />
      </div>
      <GVSnackbar />
    </div>
  );
};

export default MyAccountPage;
